/**
 * Label helpers for the admin panel's filter dropdowns.
 *
 * Every "pick a person" dropdown (Teacher / Organization, Learner) names the
 * kind of account first and the person second — "Teacher: Jane Doe". Names are
 * not unique, though: two learners called "Alex Smith" are indistinguishable in
 * the list, and picking the wrong one silently filters the E-Wallet / Earnings
 * tables to somebody else's transactions.
 *
 * So the account code goes after the name, in brackets — the same code the
 * listings show in their "From Code" / "To Code" columns, which is what an admin
 * cross-references against. Kept here rather than inline at each dropdown so
 * every list formats it identically.
 */

// "Jane Doe (SS12345)", or just "Jane Doe" when the account has no code yet
// (older rows predate code generation, and the API can send null / "").
export const withCode = (name, code) => {
  const label = name === null || name === undefined ? "" : String(name).trim();
  const value = code === null || code === undefined ? "" : String(code).trim();
  if (!value) return label;
  return label ? `${label} (${value})` : value;
};

export default withCode;
